import { ReactNode } from "react";
import { motion } from "framer-motion";

import styles from "./ui-search-banner-group.module.css";
import { useTranslations } from "next-intl";

import {
  ContestantSearchItem,
  SearchContestantsResponse,
} from "~shared/lib/api/dto";

export type UiSearchBannerGroupProps = {
  results: SearchContestantsResponse;
  renderBanner: (
    data: ContestantSearchItem & {
      numeration: number;
    },
  ) => ReactNode;
};

export function UiSearchBannerGroup({
  results,
  renderBanner,
}: UiSearchBannerGroupProps) {
  const t = useTranslations("history.search");
  return (
    <div className={styles.group}>
      {results.length > 0 ? (
        results.map((data, numeration) => renderBanner({ numeration, ...data }))
      ) : (
        <div className="px-[1.5rem] py-[0.75rem] text-center">
          {t("notFound")}
        </div>
      )}
    </div>
  );
}
